import { render, staticRenderFns } from "./ChipsPreview.vue?vue&type=template&id=7fdcb50c&scoped=true&"
import script from "./ChipsPreview.vue?vue&type=script&lang=js&"
export * from "./ChipsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ChipsPreview.vue?vue&type=style&index=0&id=7fdcb50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdcb50c",
  null
  
)

export default component.exports